export default {
  index: '首页',
  logIn: '登入',
  logOut: '退出登录',
  profile: '个人中心',
  webcomeBack: '欢迎回来',
  noName: '暂无名称'
};
